<template>
  <v-layout row wrap justify-center class="pt-8 pb-5 no-gutters">
    <v-flex xs12 class="mt-1 text-center">
      <div class="cont-titulo-white text-center">
        <h1> {{itemsec.titulo}} </h1>
      </div>
    <v-divider></v-divider>
    </v-flex>
    <v-flex sm3 pa-2>
      <div class="cont-under pa-2">
        <p class="mt-2 mb-1">Buscar</p>
        <v-text-field
          v-model="quitSearch"
          label="Búsqueda Rápida"
          hide-details
          dense
          outlined
          clear-icon="mdi-close-circle"
          clearable
          @click:clear="limpiarBusqueda"
          >
        </v-text-field>
        <v-btn block small dense color="primary" class="mt-2" @click="buscar"><v-icon left>fa-search</v-icon> Buscar</v-btn>
        <p class="mt-2 mb-1">Seleccione una categoría</p>
        <v-autocomplete
          :items="filtroCategoria"
          v-model="filtroSelect"
          dense
          outlined
          hide-details
          label="Categoria"
          :key="KeyRefresh"
        ></v-autocomplete>
        <div class="d-flex row wrap no-gutters ">
          <v-flex xs12>
            <p class="mt-2 mb-1">Seleccione Año de Publicación</p>
          </v-flex>
          <v-flex xs12>
          <v-select
            :items="filtroAnos"
            v-model="filAno"
            dense
            outlined
            hide-details
            label="Año"
            :key="KeyRefresh"
          ></v-select>
          </v-flex>
        </div>
        <v-btn block small dense color="primary" class="mt-2" @click="ejecutarFiltro"><v-icon left>mdi-filter</v-icon> Filtrar</v-btn>
        <v-btn block small v-if="filtrando" dense color="primary" class="mt-2" @click="limpiarFiltro" > <v-icon left>mdi-delete-empty</v-icon> Limpiar</v-btn>
      </div>
    </v-flex>
    <v-flex xs11 sm7>
      <div class="btn-transaccion my-1"
        v-for="(item, idx) in infoFinal" :key="'item-'+idx"
        v-show="(pag - 1) * NUM_RESULTS <= idx  && pag * NUM_RESULTS > idx"
        >
        <h3>{{item.descripcion}}</h3>
        <p>{{item.fecha_publicacion}}</p>
        <div class="cont-categoria d-flex">
          <v-chip x-small >
            {{item.categoria}}
          </v-chip>
        </div>
        <v-list flat>
          <v-list-item-group color="primary" >
            <v-list-item
              dense
              class="itemdoc"
              v-for="(doc, i) in item.archivos_api"
              :key="'doc-'+i"
              :href="doc.url" target="_blank"
            >
              <v-list-item-icon class="ma-0 mr-1">
                <v-icon small>mdi-file</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="name-doc">{{doc.nombre}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </div>
      <div>
        <div class="text-center pt-2 pb-6" v-if="this.infoFinal.length == 0 && !cardando">
          <h2>No se encontró información relacionada con los filtros seleccionados. Cambie las opciones o restablezca la información total.</h2>
          <v-btn color="primary" class="mt-4" @click="limpiarFiltro">Restablecer</v-btn>
        </div>
        <v-skeleton-loader v-if="this.infoFinal.length == 0 || cardando"
          class="mx-auto"
          max-width="100%"
          type="card-avatar, article"
        ></v-skeleton-loader>
      </div>
      <nav aria-label="Page navigation" class="text-center d-flex justify-center align-center">
        <v-btn small color="primary" v-show="pag != 1" @click.prevent="pag -= 1">
          <span>Anterior</span>
        </v-btn>
        <div class="mx-3">Total {{ infoFinal.length }}</div>
        <v-btn small color="primary" v-show="pag * NUM_RESULTS / infoFinal.length < 1" @click.prevent="pag += 1">
          <span>Siguiente</span>
        </v-btn>
      </nav>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from 'axios'
import navUser from '../components/nav-user'
import secNoticias from '../components/sec-noticias'

export default {
  components: {
    navUser,
    secNoticias
  },
  metaInfo: {
    titleTemplate: '%s| Transparencia y Acceso a la Información',
    meta: [
      { name: 'Documentos', content: 'Transparencia y Acceso a la Información' }
    ]
  },
  data () {
    return {
      itemsec: {
        titulo: 'Transparencia y Acceso a la Información'
      },
      NUM_RESULTS: 5, // Numero de resultados por página
      pag: 1, // Página inicial
      info: [],
      filtroSelect: null, // Filtro seleccionado en categoria
      filtroAnos: [], // Filtro seleccionado en fechas
      itemsFiltroCategoria: [],
      itemsFiltroAnos: [],
      filtroCategoria: [],
      filAno: null,
      infoFinal: [],
      KeyRefresh: 0,
      filtrando: false,
      cardando: false,
      filtroActivo: false,
      filtroNombre: '',
      quitSearch: ''
    }
  },
  async created () {
    this.cardando = true
    await axios
      .get('' + this.$store.state.rutaApi + 'documentos_web_v2')
      .then(response => (this.info = response.data))
    this.cardando = false
    this.info.forEach(element => {
      this.itemsFiltroCategoria.push(element.categoria) // Se extraen las categorias para filtro
      this.itemsFiltroAnos.push(element.ano_archivo) // Se extren años para filtro
    })
    let result = this.itemsFiltroCategoria.reduce((acc, item) => {
      if (!acc.includes(item)) {
      	acc.push(item)
      }
      return acc
    }, []) // Elimina las categorias que se repiten
    this.filtroCategoria = result
    this.filtroCategoria.sort() // ordena alfabéticamente las categorias
    let resultAno = this.itemsFiltroAnos.reduce((acc, item) => {
      if (!acc.includes(item)) {
      	acc.push(item)
      }
      return acc
    }, []) // Elimina años repetidos
    let anoOrdenado = resultAno.sort((a, b) => {
      return a - b
    }) // Ordena los años de menor a mayor
    this.filtroAnos = anoOrdenado // Carga los años finales
    this.infoFinal = this.info // Información a mostrar
    this.filtroActivo ? this.ejecutarFiltro() : this.filtroActivo = false
  },
  mounted () {
    this.noticiaId = this.$store.state.notiId
    this.comprobarFiltro()
  },
  watch: {
    quitSearch () {
      if (this.quitSearch === '' || null) {
        this.infoFinal = this.info // Información a mostrar
        this.pag = 1
      } else {
        return false
      }
    }
  },
  methods: {
    limpiarBusqueda () {
      this.infoFinal = this.info // Información a mostrar
    },
    buscar () {
      this.infoFinal = this.info.filter(item => {
        return item.descripcion.toLowerCase().includes(this.quitSearch.toLowerCase())
      })
    },
    comprobarFiltro () {
      let routeArr = this.$route.path.split('/')
      let filtroNombre = routeArr[routeArr.length - 1]
      // console.log(filtroNombre)
      if (filtroNombre != 'na') {
        this.filtroActivo = true
        this.filtroSelect = filtroNombre
      } else {
        return false
      }
    },
    leerMas (val) {
      this.$store.state.notiId = val
      // console.log(this.$store.state.notiId)
      this.noticiaId = val
    },
    ejecutarFiltro () {
      // console.log('Se aplicaflitro')
      this.infoFinal = []
      this.filtrando = true
      this.pag = 1
      // console.log(this.filtroSelect)
      // console.log(this.filAno)
      if (this.filAno != null && this.filtroSelect != null) {
        // console.log('tiene Ano aplicado y Categoría Aplicado')
        for (let index = 0; index < this.info.length; index++) {
          if (this.info[index].categoria === this.filtroSelect && this.info[index].ano_archivo === this.filAno) {
            this.infoFinal.push(this.info[index])
          }
        }
      } else if (this.filtroSelect == null && this.filAno != null) {
        // console.log('No seleccionó categoria')
        for (let index = 0; index < this.info.length; index++) {
          if (this.info[index].ano_archivo === this.filAno) {
            this.infoFinal.push(this.info[index])
          }
        }
      } else if (this.filtroSelect != null && this.filAno == null) {
        // console.log('No seleccionó Ano')
        for (let index = 0; index < this.info.length; index++) {
          if (this.info[index].categoria === this.filtroSelect) {
            this.infoFinal.push(this.info[index])
          }
        }
      }
    },
    limpiarFiltro () {
      this.pag = 1
      this.filtrando = false
      this.KeyRefresh++
      this.filAno = null
      this.filtroSelect = null
      this.infoFinal = []
      this.infoFinal = this.info,
      this.filtroActivo = false
      this.$router.replace({ name: 'documentos', params: { nameFiltro: 'na' } }).catch(() => {})
    }
  }
  // watch:{
  //   filAno(){
  //     console.log(this.filAno)
  //   }
  // }
}
</script>
<style lang="scss" scoped>
.contenedor{
    height: auto;
}
.bdred{
  border: solid red;
}

.btn-transaccion{
  padding: 10px;
  background-color:#FFFFFF;
  border-radius: 5px;
  border:solid #2B5AC4  1px;
  h3{
    margin: 0px;
    padding: 0px;
    color: #2B5AC4;
    font-size: 1.2em;
    text-align: left;
    line-height: 1.1em;
  }
  .open-transaccion{
    margin-left: auto;
  }
}
.cont-categoria{
  width: 100%;
}
.cont-inf{
  padding-bottom: 100px;
}
.itemdoc{
  min-height: 15px!important;
}
.name-doc{
  font-size: 12px;
}
</style>
